import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Switch } from "antd";
import {
  togglePressEnterToSendMessage,
  toggleDynamicMessageFilter,
  toggleAlwaysOpenNewMessages,
  toggleReceiveEmailNotifications,
} from "../../store/actions/general-settings";
import UserService from "../../services/user";
import "./OptionsBox.scss";

class OptionsBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onMoreOptionsClick = this.onMoreOptionsClick.bind(this);
    this.toggleDynamicMessageFilter =
      this.toggleDynamicMessageFilter.bind(this);
    this.toggleAlwaysOpenNewMessages =
      this.toggleAlwaysOpenNewMessages.bind(this);
    this.togglePressEnterToSendMessage =
      this.togglePressEnterToSendMessage.bind(this);
    this.toggleReceiveEmailNotifications =
      this.toggleReceiveEmailNotifications.bind(this);
  }

  onOptionClick(e) {
    e.stopPropagation();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      event.target !== null
    ) {
      event.stopPropagation();
      this.props.onClickAway();
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  onMoreOptionsClick() {
    this.props.toggleMoreOptions();
  }

  toggleDynamicMessageFilter() {
    this.props.toggleDynamicMessageFilter();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: !this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      emailNotification: this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleAlwaysOpenNewMessages() {
    this.props.toggleAlwaysOpenNewMessages();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: !this.props.options.alwaysOpenNewMessages,
      emailNotification: this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  togglePressEnterToSendMessage() {
    this.props.togglePressEnterToSendMessage();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      emailNotification: this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: !this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleReceiveEmailNotifications() {
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      emailNotification: !this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
    this.props.toggleReceiveEmailNotifications();
  }

  render() {
    const {
      dynamicMessageFilter,
      alwaysOpenNewMessages,
      pressEnterToSendMessage,
      receiveEmailNotifications,
    } = this.props.options;

    return (
      <div
        className={`options-box ${this.props.direction}`}
        onClick={(e) => e.stopPropagation()}
        ref={this.setWrapperRef}
      >
        <span className="options-box-section">
          <FormattedMessage id="chat.settings" />
        </span>
        <span className="options-box-option" onClick={this.onOptionClick}>
          <FormattedMessage id="settings.dynamicMessage" />
          <Switch
            defaultChecked={dynamicMessageFilter}
            onChange={this.toggleDynamicMessageFilter}
          />
        </span>
        <span className="options-box-option" onClick={this.onOptionClick}>
          <FormattedMessage id="settings.alwaysOpenNewMessages" />
          <Switch
            defaultChecked={alwaysOpenNewMessages}
            onChange={this.toggleAlwaysOpenNewMessages}
          />
        </span>
        <span className="options-box-option" onClick={this.onOptionClick}>
          <FormattedMessage id="settings.pressEnterToSendMessage" />
          <Switch
            defaultChecked={pressEnterToSendMessage}
            onChange={this.togglePressEnterToSendMessage}
          />
        </span>
        <span className="options-box-option" onClick={this.onOptionClick}>
          <FormattedMessage id="settings.receiveEmailNotifications" />
          <Switch
            defaultChecked={receiveEmailNotifications}
            onChange={this.toggleReceiveEmailNotifications}
          />
        </span>
        <span className="separator"></span>
        <span
          className="options-box-option more-options"
          onClick={this.onMoreOptionsClick}
        >
          <FormattedMessage id="settings.more" />
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    options: state.GeneralSettings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleDynamicMessageFilter: (id) => dispatch(toggleDynamicMessageFilter()),
  toggleAlwaysOpenNewMessages: (id) => dispatch(toggleAlwaysOpenNewMessages()),
  togglePressEnterToSendMessage: (id) =>
    dispatch(togglePressEnterToSendMessage()),
  toggleReceiveEmailNotifications: (id) =>
    dispatch(toggleReceiveEmailNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OptionsBox);
